import * as React from "react";
import { SVGProps, memo } from "react";
const SvgActionsActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 19"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#333",
      }}
      d="M16 9.8c0 .7-.6 1.3-1.3 1.3h-.5c-.7 0-1.3-.6-1.3-1.3v-.5c.1-.7.7-1.3 1.4-1.3h.5c.6 0 1.2.6 1.2 1.3v.5zM11 9.8c0 .7-.6 1.3-1.3 1.3h-.4C8.6 11 8 10.4 8 9.8v-.5C8 8.6 8.6 8 9.3 8h.5c.6 0 1.2.6 1.2 1.3v.5zM6 9.8c0 .6-.6 1.2-1.3 1.2h-.4C3.6 11 3 10.4 3 9.8v-.5C3 8.6 3.6 8 4.3 8h.5C5.4 8 6 8.6 6 9.3v.5z"
    />
  </svg>
);
const Memo = memo(SvgActionsActive);
export default Memo;
